document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

class APHeader extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-menu-toggle]');
    this.panel = this.querySelector('[data-mobile-menu]');
    if (!this.toggle || !this.panel) return;
    this.toggle.addEventListener('click', () => this.setOpen(this.toggle.getAttribute('aria-expanded') !== 'true'));
    this.querySelectorAll('[data-menu-close]').forEach((button) => button.addEventListener('click', () => this.setOpen(false)));
  }

  setOpen(open) {
    this.toggle.setAttribute('aria-expanded', String(open));
    this.panel.hidden = !open;
    document.body.classList.toggle('menu-open', open);
  }
}

class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.button = this.querySelector('[type="submit"]');
    this.status = this.querySelector('[data-product-status]');
    if (!this.form) return;
    this.form.addEventListener('submit', (event) => this.submit(event));
  }

  async submit(event) {
    event.preventDefault();
    this.button.setAttribute('aria-disabled', 'true');
    this.button.classList.add('is-loading');
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(this.form)
      });
      if (!response.ok) throw new Error((await response.json()).description || 'Unable to add this item.');
      const item = await response.json();
      if (this.status) this.status.textContent = item.title + ' was added to your bag.';
      document.dispatchEvent(new CustomEvent('cart:updated'));
      window.setTimeout(() => { window.location.href = window.Shopify.routes.root + 'cart'; }, 500);
    } catch (error) {
      if (this.status) this.status.textContent = error.message;
    } finally {
      this.button.removeAttribute('aria-disabled');
      this.button.classList.remove('is-loading');
    }
  }
}

class VariantSelect extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('select');
    this.form = document.getElementById(this.dataset.form);
    if (!this.select || !this.form) return;
    this.select.addEventListener('change', () => {
      this.form.querySelector('[name="id"]').value = this.select.value;
      const option = this.select.selectedOptions[0];
      const price = document.querySelector('[data-product-price]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
    });
  }
}

customElements.define('ap-header', APHeader);
customElements.define('product-form', ProductForm);
customElements.define('variant-select', VariantSelect);
